<template>
  <section id="home">
    <div class="h-top-container">
      <div class="ht-header-container">
        <div class="page-label">
          System Health
        </div>
        <SelectedPartner />
      </div>
      <div class="ht-content-container">
        <SystemHealthDashboard />
      </div>
    </div>
    <div class="h-body-container">
      <div class="h-content-container">
        <SystemHealthTable />
      </div>
    </div>
    <ActionModal />
  </section>
</template>

<script>

import SystemHealthDashboard from '@shared/components/systemHealth/SystemHealthDashboard.vue';
import SystemHealthTable from '@shared/components/systemHealth/SystemHealthTable.vue';
import ActionModal from '@shared/components/systemHealth/ActionModal.vue';
import SelectedPartner from '@shared/components/admin/SelectedPartner.vue';
import adminMixin from '@shared/mixins/adminMixin';
import systemHealthMixin from '@shared/mixins/systemHealthMixin';

export default {
  name: 'SystemHealth',
  metaInfo: {
    title: 'SmartAC.com | System Health',
  },
  components: {
    SelectedPartner,
    SystemHealthDashboard,
    SystemHealthTable,
    ActionModal,
  },
  mixins: [adminMixin, systemHealthMixin],
  watch: {
    resetSystemHealthFlag() {
      if (this.resetSystemHealthFlag) {
        this.$store.dispatch('getSystemHealth');
      }
    },
    selectedCorpId() {
      this.initialLoad();
    },
  },
  mounted() {
    if (this.isManufactureAdmin) {
      this.$router.replace('/quality');
    } else {
      this.initialLoad();
    }
  },
  methods: {
    async initialLoad() {
      this.$store.dispatch('setSystemHealthHeaders');
      await this.$store.dispatch('getSystemHealth');
    },
  },
};
</script>

<style lang="scss" scoped>
section#home {
  @include section-container;
  .h-top-container {
    @include section-top-container;
    .ht-header-container {
      @include section-header-container;
      justify-content: space-between;
      align-items: center;
    }
    .ht-content-container {
      min-width: 1100px;
      max-width: 1705px;
      max-height: 400px;
      overflow: hidden;
      width: 100%;
    }
  }
  .h-body-container {
    @include section-body-container;
    .h-content-container {
      @include section-content-container;
    }
  }
}
</style>
